import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GungBase } from 'gung-standard';
import { BehaviorSubject, catchError, defaultIfEmpty, isEmpty, Observable, of, ReplaySubject, Subject, switchMap, tap, throwError } from 'rxjs';

export interface MySetup {
  name?: string;
  address1?: string;
  address2?: string;
  zipCode?: string;
  city?: string;
  organizationNumber?: string;
  email?: string;
  telephone?: string;
  webAddress?: string;
  currency?: string;
  userId?: string;
  currencyRate?: number;
  markUp?: number;
  extra?: { [s: string]: any } | null;
}


@Injectable({
  providedIn: 'root'
})
export class CarLinerMysetupService {

  initSetup = {} as MySetup;

  protected currentSetup: Subject<MySetup>;

  constructor(protected http: HttpClient) {

  }

  getMySetupServer(): Observable<MySetup> {
    this.currentSetup = new ReplaySubject<MySetup>();
    const url = `json/caroliner/my-setup `;
    return this.http.get<MySetup>(url).pipe(
      catchError(error => {
        if (error.status === 404) {
          return of(this.initSetup);
        } else {
          return error(error);
        }
      }), 
      defaultIfEmpty(this.initSetup),
      switchMap(mySetup => {
        this.currentSetup.next(mySetup);
        return this.currentSetup;
    }), );

  }

  getMySetup(): Observable<MySetup>{
    /* const setuptest = {
      currencyRate: 2,
      currency: 'EUR',
      markUp: 1,
      address1: '33',
      address2: 'eeer',
      city: 'city',
      email: 'eerr',
      extra: null,
      name: "test",
      organizationNumber: "sajl",
      telephone: "eeer",
      userId: 'Gung',
      webAddress: 'etete',
      zipCode: 'etete'
    };
    return of(setuptest); */
    if(!this.currentSetup){
      return this.getMySetupServer()
    }
    return this.currentSetup.asObservable();
  }

  saveMySetup(mySetup: MySetup): Observable<MySetup> {
    const url = `json/caroliner/my-setup`;
    return this.http.post<MySetup>(url, mySetup).pipe(tap(mySetup => {
      this.currentSetup.next(mySetup);
    }));;
  }
}
